
// @ts-nocheck
import locale_en_46js_c2f87d3b from "#nuxt-i18n/c2f87d3b";
import locale_es_46js_f46ce4ad from "#nuxt-i18n/f46ce4ad";
import locale_fr_46js_72ba9ba7 from "#nuxt-i18n/72ba9ba7";
import locale_de_46js_fc8d827c from "#nuxt-i18n/fc8d827c";
import locale_pt_46js_dfb49f02 from "#nuxt-i18n/dfb49f02";
import locale_it_46js_a18408d6 from "#nuxt-i18n/a18408d6";
import locale_nl_46js_ed01be93 from "#nuxt-i18n/ed01be93";
import locale_pl_46js_3eebae2c from "#nuxt-i18n/3eebae2c";
import locale_jp_46js_bb089924 from "#nuxt-i18n/bb089924";
import locale_en_46ts_9366fc00 from "#nuxt-i18n/9366fc00";

export const localeCodes =  [
  "us",
  "uk",
  "au",
  "ca",
  "ie",
  "nz",
  "za",
  "es",
  "cl",
  "ar",
  "mx",
  "fr",
  "ca-fr",
  "be",
  "de",
  "ch",
  "ch-fr",
  "at",
  "pt",
  "br",
  "it",
  "nl",
  "be-nl",
  "pl",
  "hu",
  "cy",
  "gr",
  "jp",
  "hr",
  "bg",
  "cz",
  "dk",
  "ee",
  "fi",
  "lv",
  "lt",
  "sk",
  "si",
  "se",
  "al",
  "ba",
  "is",
  "lu",
  "rs",
  "tr",
  "en"
]

export const localeLoaders = {
  us: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  au: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  ca: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  ie: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  nz: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  za: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46js_f46ce4ad",
      load: () => Promise.resolve(locale_es_46js_f46ce4ad),
      cache: true
    }
  ],
  cl: [
    {
      key: "locale_es_46js_f46ce4ad",
      load: () => Promise.resolve(locale_es_46js_f46ce4ad),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_es_46js_f46ce4ad",
      load: () => Promise.resolve(locale_es_46js_f46ce4ad),
      cache: true
    }
  ],
  mx: [
    {
      key: "locale_es_46js_f46ce4ad",
      load: () => Promise.resolve(locale_es_46js_f46ce4ad),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46js_72ba9ba7",
      load: () => Promise.resolve(locale_fr_46js_72ba9ba7),
      cache: true
    },
    {
      key: "locale_fr_46js_72ba9ba7",
      load: () => Promise.resolve(locale_fr_46js_72ba9ba7),
      cache: true
    }
  ],
  "ca-fr": [
    {
      key: "locale_fr_46js_72ba9ba7",
      load: () => Promise.resolve(locale_fr_46js_72ba9ba7),
      cache: true
    }
  ],
  be: [
    {
      key: "locale_fr_46js_72ba9ba7",
      load: () => Promise.resolve(locale_fr_46js_72ba9ba7),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46js_fc8d827c",
      load: () => Promise.resolve(locale_de_46js_fc8d827c),
      cache: true
    }
  ],
  ch: [
    {
      key: "locale_de_46js_fc8d827c",
      load: () => Promise.resolve(locale_de_46js_fc8d827c),
      cache: true
    }
  ],
  "ch-fr": [
    {
      key: "locale_fr_46js_72ba9ba7",
      load: () => Promise.resolve(locale_fr_46js_72ba9ba7),
      cache: true
    }
  ],
  at: [
    {
      key: "locale_de_46js_fc8d827c",
      load: () => Promise.resolve(locale_de_46js_fc8d827c),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46js_dfb49f02",
      load: () => Promise.resolve(locale_pt_46js_dfb49f02),
      cache: true
    }
  ],
  br: [
    {
      key: "locale_pt_46js_dfb49f02",
      load: () => Promise.resolve(locale_pt_46js_dfb49f02),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46js_a18408d6",
      load: () => Promise.resolve(locale_it_46js_a18408d6),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46js_ed01be93",
      load: () => Promise.resolve(locale_nl_46js_ed01be93),
      cache: true
    }
  ],
  "be-nl": [
    {
      key: "locale_nl_46js_ed01be93",
      load: () => Promise.resolve(locale_nl_46js_ed01be93),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46js_3eebae2c",
      load: () => Promise.resolve(locale_pl_46js_3eebae2c),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_de_46js_fc8d827c",
      load: () => Promise.resolve(locale_de_46js_fc8d827c),
      cache: true
    }
  ],
  cy: [
    {
      key: "locale_es_46js_f46ce4ad",
      load: () => Promise.resolve(locale_es_46js_f46ce4ad),
      cache: true
    }
  ],
  gr: [
    {
      key: "locale_es_46js_f46ce4ad",
      load: () => Promise.resolve(locale_es_46js_f46ce4ad),
      cache: true
    }
  ],
  jp: [
    {
      key: "locale_jp_46js_bb089924",
      load: () => Promise.resolve(locale_jp_46js_bb089924),
      cache: true
    }
  ],
  hr: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  bg: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  cz: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  dk: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  ee: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  lv: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  lt: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  si: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  se: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  al: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  ba: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  is: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  lu: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  rs: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46ts_9366fc00",
      load: () => Promise.resolve(locale_en_46ts_9366fc00),
      cache: true
    },
    {
      key: "locale_en_46js_c2f87d3b",
      load: () => Promise.resolve(locale_en_46js_c2f87d3b),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "us",
      storyblok: "en",
      iso: "en-US",
      lang: "English",
      name: "United States",
      language: "en-US",
      _hreflang: "en-US",
      _sitemap: "en-US",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "United Kingdom",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "au",
      storyblok: "en",
      iso: "en-AU",
      lang: "English",
      name: "Australia",
      language: "en-AU",
      _hreflang: "en-AU",
      _sitemap: "en-AU",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ca",
      storyblok: "en",
      iso: "en-CA",
      lang: "English",
      name: "Canada",
      language: "en-CA",
      _hreflang: "en-CA",
      _sitemap: "en-CA",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ie",
      storyblok: "en",
      iso: "en-IE",
      lang: "English",
      name: "Ireland",
      language: "en-IE",
      _hreflang: "en-IE",
      _sitemap: "en-IE",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "nz",
      storyblok: "en",
      iso: "en-NZ",
      lang: "English",
      name: "New Zealand",
      language: "en-NZ",
      _hreflang: "en-NZ",
      _sitemap: "en-NZ",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "za",
      storyblok: "en",
      iso: "en-ZA",
      lang: "English",
      name: "South Africa",
      language: "en-ZA",
      _hreflang: "en-ZA",
      _sitemap: "en-ZA",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      storyblok: "es",
      iso: "es-ES",
      lang: "Spanish",
      name: "España",
      language: "es-ES",
      _hreflang: "es-ES",
      _sitemap: "es-ES",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
          cache: undefined
        }
      ]
    },
    {
      code: "cl",
      storyblok: "es",
      iso: "es-CL",
      lang: "Spanish",
      name: "Chile",
      language: "es-CL",
      _hreflang: "es-CL",
      _sitemap: "es-CL",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      storyblok: "es",
      iso: "es-AR",
      lang: "Spanish",
      name: "Argentina",
      language: "es-AR",
      _hreflang: "es-AR",
      _sitemap: "es-AR",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
          cache: undefined
        }
      ]
    },
    {
      code: "mx",
      storyblok: "es",
      iso: "es-MX",
      lang: "Spanish",
      name: "México",
      language: "es-MX",
      _hreflang: "es-MX",
      _sitemap: "es-MX",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      storyblok: "fr",
      iso: "fr-FR",
      lang: "French",
      name: "France",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
          cache: undefined
        },
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ca-fr",
      storyblok: "fr",
      iso: "fr-CA",
      lang: "French",
      name: "Canada",
      language: "fr-CA",
      _hreflang: "fr-CA",
      _sitemap: "fr-CA",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
          cache: undefined
        }
      ]
    },
    {
      code: "be",
      storyblok: "fr",
      iso: "fr-BE",
      lang: "French",
      name: "Belgique",
      language: "fr-BE",
      _hreflang: "fr-BE",
      _sitemap: "fr-BE",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      storyblok: "de",
      iso: "de-DE",
      lang: "German",
      name: "Deutschland",
      language: "de-DE",
      _hreflang: "de-DE",
      _sitemap: "de-DE",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/de.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ch",
      storyblok: "de",
      iso: "de-CH",
      lang: "German",
      name: "Schweiz",
      language: "de-CH",
      _hreflang: "de-CH",
      _sitemap: "de-CH",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/de.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ch-fr",
      storyblok: "fr",
      iso: "fr-CH",
      lang: "French",
      name: "Suisse",
      language: "fr-CH",
      _hreflang: "fr-CH",
      _sitemap: "fr-CH",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
          cache: undefined
        }
      ]
    },
    {
      code: "at",
      storyblok: "de",
      iso: "de-AT",
      lang: "German",
      name: "Österreich",
      language: "de-AT",
      _hreflang: "de-AT",
      _sitemap: "de-AT",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/de.js",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      storyblok: "pt",
      iso: "pt-PT",
      lang: "Portuguese",
      name: "Portugal",
      language: "pt-PT",
      _hreflang: "pt-PT",
      _sitemap: "pt-PT",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/pt.js",
          cache: undefined
        }
      ]
    },
    {
      code: "br",
      storyblok: "pt",
      iso: "pt-BR",
      lang: "Portuguese",
      name: "Brasil",
      language: "pt-BR",
      _hreflang: "pt-BR",
      _sitemap: "pt-BR",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/pt.js",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      storyblok: "it",
      iso: "it-IT",
      lang: "Italian",
      name: "Italia",
      language: "it-IT",
      _hreflang: "it-IT",
      _sitemap: "it-IT",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/it.js",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      storyblok: "nl",
      iso: "nl-NL",
      lang: "Dutch",
      name: "Nederland",
      language: "nl-NL",
      _hreflang: "nl-NL",
      _sitemap: "nl-NL",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/nl.js",
          cache: undefined
        }
      ]
    },
    {
      code: "be-nl",
      storyblok: "nl",
      iso: "nl-BE",
      lang: "Dutch",
      name: "België",
      language: "nl-BE",
      _hreflang: "nl-BE",
      _sitemap: "nl-BE",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/nl.js",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      storyblok: "pl",
      iso: "pl-PL",
      lang: "Polish",
      name: "Polska",
      language: "pl-PL",
      _hreflang: "pl-PL",
      _sitemap: "pl-PL",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/pl.js",
          cache: undefined
        }
      ]
    },
    {
      code: "hu",
      storyblok: "de",
      iso: "de-HU",
      lang: "German",
      name: "Hungary",
      language: "de-HU",
      _hreflang: "de-HU",
      _sitemap: "de-HU",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/de.js",
          cache: undefined
        }
      ]
    },
    {
      code: "cy",
      storyblok: "es",
      iso: "es-CY",
      lang: "Spanish",
      name: "Cyprus",
      language: "es-CY",
      _hreflang: "es-CY",
      _sitemap: "es-CY",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
          cache: undefined
        }
      ]
    },
    {
      code: "gr",
      storyblok: "es",
      iso: "es-GR",
      lang: "Spanish",
      name: "Greece",
      language: "es-GR",
      _hreflang: "es-GR",
      _sitemap: "es-GR",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
          cache: undefined
        }
      ]
    },
    {
      code: "jp",
      storyblok: "jp",
      iso: "jp-JP",
      lang: "Japanese",
      name: "日本",
      language: "jp-JP",
      _hreflang: "jp-JP",
      _sitemap: "jp-JP",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/jp.js",
          cache: undefined
        }
      ]
    },
    {
      code: "hr",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Hrvatska",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "bg",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "България",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "cz",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Česká republika",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "dk",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Denmark",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ee",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Eesti",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Suomi",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "lv",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Latvija",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "lt",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Lietuva",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "sk",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Slovensko",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "si",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Slovenija",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "se",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Sverige",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "al",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Shqipëria",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ba",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Bosna",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "is",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Ísland",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "lu",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Luxembourg",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "rs",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Srbija",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      storyblok: "en",
      iso: "en-GB",
      lang: "English",
      name: "Türkiye",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      iso: "en-GB",
      lang: "English",
      name: "United Kingdom",
      storyblok: "en",
      files: [
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/packages/base/i18n/lang/en.ts",
          cache: undefined
        },
        {
          path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "lang/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {
    index: false
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "us",
    storyblok: "en",
    iso: "en-US",
    lang: "English",
    name: "United States",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "United Kingdom",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "au",
    storyblok: "en",
    iso: "en-AU",
    lang: "English",
    name: "Australia",
    language: "en-AU",
    _hreflang: "en-AU",
    _sitemap: "en-AU",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ca",
    storyblok: "en",
    iso: "en-CA",
    lang: "English",
    name: "Canada",
    language: "en-CA",
    _hreflang: "en-CA",
    _sitemap: "en-CA",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ie",
    storyblok: "en",
    iso: "en-IE",
    lang: "English",
    name: "Ireland",
    language: "en-IE",
    _hreflang: "en-IE",
    _sitemap: "en-IE",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "nz",
    storyblok: "en",
    iso: "en-NZ",
    lang: "English",
    name: "New Zealand",
    language: "en-NZ",
    _hreflang: "en-NZ",
    _sitemap: "en-NZ",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "za",
    storyblok: "en",
    iso: "en-ZA",
    lang: "English",
    name: "South Africa",
    language: "en-ZA",
    _hreflang: "en-ZA",
    _sitemap: "en-ZA",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    storyblok: "es",
    iso: "es-ES",
    lang: "Spanish",
    name: "España",
    language: "es-ES",
    _hreflang: "es-ES",
    _sitemap: "es-ES",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
        cache: undefined
      }
    ]
  },
  {
    code: "cl",
    storyblok: "es",
    iso: "es-CL",
    lang: "Spanish",
    name: "Chile",
    language: "es-CL",
    _hreflang: "es-CL",
    _sitemap: "es-CL",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    storyblok: "es",
    iso: "es-AR",
    lang: "Spanish",
    name: "Argentina",
    language: "es-AR",
    _hreflang: "es-AR",
    _sitemap: "es-AR",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
        cache: undefined
      }
    ]
  },
  {
    code: "mx",
    storyblok: "es",
    iso: "es-MX",
    lang: "Spanish",
    name: "México",
    language: "es-MX",
    _hreflang: "es-MX",
    _sitemap: "es-MX",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    storyblok: "fr",
    iso: "fr-FR",
    lang: "French",
    name: "France",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
        cache: undefined
      },
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ca-fr",
    storyblok: "fr",
    iso: "fr-CA",
    lang: "French",
    name: "Canada",
    language: "fr-CA",
    _hreflang: "fr-CA",
    _sitemap: "fr-CA",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
        cache: undefined
      }
    ]
  },
  {
    code: "be",
    storyblok: "fr",
    iso: "fr-BE",
    lang: "French",
    name: "Belgique",
    language: "fr-BE",
    _hreflang: "fr-BE",
    _sitemap: "fr-BE",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    storyblok: "de",
    iso: "de-DE",
    lang: "German",
    name: "Deutschland",
    language: "de-DE",
    _hreflang: "de-DE",
    _sitemap: "de-DE",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/de.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ch",
    storyblok: "de",
    iso: "de-CH",
    lang: "German",
    name: "Schweiz",
    language: "de-CH",
    _hreflang: "de-CH",
    _sitemap: "de-CH",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/de.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ch-fr",
    storyblok: "fr",
    iso: "fr-CH",
    lang: "French",
    name: "Suisse",
    language: "fr-CH",
    _hreflang: "fr-CH",
    _sitemap: "fr-CH",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/fr.js",
        cache: undefined
      }
    ]
  },
  {
    code: "at",
    storyblok: "de",
    iso: "de-AT",
    lang: "German",
    name: "Österreich",
    language: "de-AT",
    _hreflang: "de-AT",
    _sitemap: "de-AT",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/de.js",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    storyblok: "pt",
    iso: "pt-PT",
    lang: "Portuguese",
    name: "Portugal",
    language: "pt-PT",
    _hreflang: "pt-PT",
    _sitemap: "pt-PT",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/pt.js",
        cache: undefined
      }
    ]
  },
  {
    code: "br",
    storyblok: "pt",
    iso: "pt-BR",
    lang: "Portuguese",
    name: "Brasil",
    language: "pt-BR",
    _hreflang: "pt-BR",
    _sitemap: "pt-BR",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/pt.js",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    storyblok: "it",
    iso: "it-IT",
    lang: "Italian",
    name: "Italia",
    language: "it-IT",
    _hreflang: "it-IT",
    _sitemap: "it-IT",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/it.js",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    storyblok: "nl",
    iso: "nl-NL",
    lang: "Dutch",
    name: "Nederland",
    language: "nl-NL",
    _hreflang: "nl-NL",
    _sitemap: "nl-NL",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/nl.js",
        cache: undefined
      }
    ]
  },
  {
    code: "be-nl",
    storyblok: "nl",
    iso: "nl-BE",
    lang: "Dutch",
    name: "België",
    language: "nl-BE",
    _hreflang: "nl-BE",
    _sitemap: "nl-BE",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/nl.js",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    storyblok: "pl",
    iso: "pl-PL",
    lang: "Polish",
    name: "Polska",
    language: "pl-PL",
    _hreflang: "pl-PL",
    _sitemap: "pl-PL",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/pl.js",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    storyblok: "de",
    iso: "de-HU",
    lang: "German",
    name: "Hungary",
    language: "de-HU",
    _hreflang: "de-HU",
    _sitemap: "de-HU",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/de.js",
        cache: undefined
      }
    ]
  },
  {
    code: "cy",
    storyblok: "es",
    iso: "es-CY",
    lang: "Spanish",
    name: "Cyprus",
    language: "es-CY",
    _hreflang: "es-CY",
    _sitemap: "es-CY",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
        cache: undefined
      }
    ]
  },
  {
    code: "gr",
    storyblok: "es",
    iso: "es-GR",
    lang: "Spanish",
    name: "Greece",
    language: "es-GR",
    _hreflang: "es-GR",
    _sitemap: "es-GR",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/es.js",
        cache: undefined
      }
    ]
  },
  {
    code: "jp",
    storyblok: "jp",
    iso: "jp-JP",
    lang: "Japanese",
    name: "日本",
    language: "jp-JP",
    _hreflang: "jp-JP",
    _sitemap: "jp-JP",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/jp.js",
        cache: undefined
      }
    ]
  },
  {
    code: "hr",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Hrvatska",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "bg",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "България",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "cz",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Česká republika",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "dk",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Denmark",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ee",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Eesti",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Suomi",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "lv",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Latvija",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "lt",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Lietuva",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "sk",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Slovensko",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "si",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Slovenija",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "se",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Sverige",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "al",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Shqipëria",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ba",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Bosna",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "is",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Ísland",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "lu",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Luxembourg",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "rs",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Srbija",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    storyblok: "en",
    iso: "en-GB",
    lang: "English",
    name: "Türkiye",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    iso: "en-GB",
    lang: "English",
    name: "United Kingdom",
    storyblok: "en",
    files: [
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/packages/base/i18n/lang/en.ts",
        cache: undefined
      },
      {
        path: "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/i18n/lang/en.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/